import React from 'react'
import { View, Platform, KeyboardAvoidingView } from 'react-native'

let KeyboardView = KeyboardAvoidingView
if (Platform.OS === 'web') {
  KeyboardView = View
}

export default KeyboardView
